module.exports = __webpack_public_path__ + "img/border_rectangle1.42defbb7.svg";